module.exports = __webpack_public_path__ + "img/articles-link.5db45683.svg";